import { ConfigType, User } from '../types/config';

/**
 * Configurações do sistema ConfereAí
 * Serviço de configuração global da aplicação
 */
export const Config: ConfigType = {
  /**
   * URL base da API do backend - seleciona automaticamente baseado no ambiente
   */
  API_BASE_URL: process.env.REACT_APP_ENVIRONMENT === 'development' 
    ? (process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:3001/api')
    : (process.env.REACT_APP_API_BASE_URL || 'https://api-confereai.robotia.com.br/api'),

  /**
   * URLs específicas dos endpoints da API
   */
  API_ENDPOINTS: {
    // Autenticação
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    USER_INFO: '/auth/me',
    REFRESH_TOKEN: '/auth/refresh-token',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/usuarios/redefinir-senha',
    CONFIRM_EMAIL: '/auth/confirm-email',
    RESEND_CONFIRMATION: '/auth/resend-confirmation',

    // Registro
    REGISTER: '/registro/empresa',
    
    // Checklists
    CHECKLISTS: '/checklists',
    CHECKLIST_BY_ID: '/checklists/:id',
    CHECKLIST_ITEMS: '/checklists/:id/itens',
    CHECKLIST_ITEM_BY_CHECKLIST: '/checklists/:checklistId/itens/:itemId',
    CHECKLIST_STATS: '/checklists/estatisticas',
    CHECKLIST_BY_VEHICLE: '/checklists/veiculo/:veiculoId',
    
    // Itens de Checklist (modelos/itens padrão)
    CHECKLIST_ITEMS_DEFAULT: '/checklists/itens-padrao',
    CHECKLIST_ITEMS_MANAGEMENT: '/itens-checklist',
    CHECKLIST_ITEM_BY_ID: '/itens-checklist/:id',
    CHECKLIST_ITEMS_STATS: '/itens-checklist/estatisticas',
    
    // Veículos
    VEHICLES: '/veiculos',
    VEHICLE_BY_ID: '/veiculos/:id',
    
    // Motoristas
    DRIVERS: '/motoristas',
    DRIVER_BY_ID: '/motoristas/:id',

    // Usuários
    USERS: '/usuarios',
    USER_BY_ID: '/usuarios/:id',
    PERFIL: '/usuarios/perfil',

    // Uploads
    UPLOADS: '/uploads',
    UPLOADS_TEST_CONNECTION: '/uploads/test-connection',
    
    // Equipamentos
    EQUIPMENTS: '/equipamentos',
    EQUIPMENT_BY_ID: '/equipamentos/:id',
    EQUIPMENT_STATS: '/equipamentos/stats',

    // Grupos de Checklist
    CHECKLIST_GROUPS: '/grupos-checklist',
    CHECKLIST_GROUP_BY_ID: '/grupos-checklist/:id',
    CHECKLIST_GROUP_STATS: '/grupos-checklist/estatisticas',
    CHECKLIST_GROUP_BY_TYPE: '/grupos-checklist/tipo/:tipo',
    CHECKLIST_GROUP_ITEMS: '/grupos-checklist/:id/itens',
    CHECKLIST_GROUP_ITEM_BY_ID: '/grupos-checklist/:id/itens/:itemId',
    CHECKLIST_GROUP_ITEMS_AVAILABLE: '/grupos-checklist/:id/itens/disponiveis',
    CHECKLIST_GROUP_ITEM_ORDER: '/grupos-checklist/:id/itens/:itemId/ordem',
    CHECKLIST_GROUPS_BY_ITEM: '/grupos-checklist/item/:itemId/grupos',

    // Agendamentos
    SCHEDULES: '/agendamentos',
    SCHEDULE_BY_ID: '/agendamentos/:id',

    // Dashboard
    DASHBOARD_STATS: '/dashboard/estatisticas',
    DASHBOARD_EVOLUCAO_CHECKLISTS: '/dashboard/evolucao-checklists',
    DASHBOARD_ATIVIDADES_RECENTES: '/dashboard/atividades-recentes',
    DASHBOARD_VEICULOS_PROBLEMAS: '/dashboard/veiculos-problemas',

    // WhatsApp
    WHATSAPP_CONNECTIONS: '/whatsapp/connections',
    WHATSAPP_CONNECTION_BY_ID: '/whatsapp/connections/:id',
    WHATSAPP_CONNECT: '/whatsapp/connections/:id/connect',
    WHATSAPP_DISCONNECT: '/whatsapp/connections/:id/disconnect',
    WHATSAPP_QR_CODE: '/whatsapp/connections/:id/qrcode',
    WHATSAPP_SEND_MESSAGE: '/whatsapp/connections/:id/send-message',
    WHATSAPP_STATUS: '/whatsapp/connections/:id/status',
    WHATSAPP_INSTANCE_CONNECT: '/whatsapp/instance/connect/:instanceName',
    WHATSAPP_API_KEY: '/whatsapp/:id/api-key',
    WHATSAPP_API_KEY_GENERATE: '/whatsapp/:id/api-key/generate',

    // Chatbot Padrão
    WHATSAPP_CHATBOT_CONFIG: '/whatsapp/:id/chatbot',
    WHATSAPP_CHATBOT_RESET: '/whatsapp/:id/chatbot/reset',

    // Contatos Não Identificados
    WHATSAPP_CONTATOS_NAO_IDENTIFICADOS: '/whatsapp/contatos-nao-identificados',
    WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_STATS: '/whatsapp/contatos-nao-identificados/estatisticas',
    WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_VINCULAR: '/whatsapp/contatos-nao-identificados/:id/vincular',
    WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_IGNORAR: '/whatsapp/contatos-nao-identificados/:id/ignorar',
    WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_MOTORISTAS: '/whatsapp/contatos-nao-identificados/motoristas-disponiveis',

    // Checklist Personalizado por Veículo
    VEHICULO_CHECKLISTS: '/veiculo-checklists',
    VEHICULO_CHECKLIST_BY_ID: '/veiculo-checklists/:id',
    VEHICULO_CHECKLIST_BY_VEHICLE: '/veiculos/:id/checklist-personalizado',
    VEHICULO_CHECKLIST_JSON: '/veiculos/:id/checklist-personalizado/json',
    VEHICULO_CHECKLIST_GROUPS: '/veiculo-checklists/:id/grupos',

    // Checklist Personalizado Adaptado (APIs compatíveis com frontend)
    VEHICULO_CHECKLIST_ADAPTADO_BY_VEHICLE: '/veiculos/:id/checklist-personalizado-adaptado',
    VEHICULO_CHECKLISTS_ADAPTADO: '/veiculo-checklists-adaptado',
    VEHICULO_CHECKLIST_ADAPTADO_BY_ID: '/veiculo-checklists-adaptado/:id',

    // Ocorrências
    OCCURRENCES: '/ocorrencias',
    OCCURRENCE_BY_ID: '/ocorrencias/:id',
    OCCURRENCE_STATISTICS: '/ocorrencias/estatisticas/geral',
    OCCURRENCE_RESOLVE: '/ocorrencias/:id/resolver',

    // Relatórios
    REPORT_EQUIPMENT_PRODUCTIVITY: '/relatorios/produtividade-equipamentos',
    REPORT_CHECKLISTS: '/relatorios/checklists',
    REPORT_VEHICLES: '/relatorios/veiculos',
    REPORT_OCCURRENCES: '/relatorios/ocorrencias',
    REPORT_EXPORT_CSV: '/relatorios/exportar/:tipo/csv',

    // Abastecimentos
    FUELINGS: '/abastecimentos',
    FUELING_BY_ID: '/abastecimentos/:id',
    FUELING_STATS: '/abastecimentos/estatisticas',
    FUELING_IMPORT_CTA_SMART: '/abastecimentos/importar/cta-smart',
    FUELING_IMPORTS: '/abastecimentos/importacoes',
    FUELING_IMPORT_BY_ID: '/abastecimentos/importacoes/:id',
    FUELING_VINCULAR_ORFAOS: '/abastecimentos/vincular-orfaos',

    // Integrações
    INTEGRATIONS: '/integracoes',
    INTEGRATION_BY_ID: '/integracoes/:id',
    INTEGRATION_BY_TYPE: '/integracoes/tipo/:tipo',
    INTEGRATION_AVAILABLE_FIELDS: '/integracoes/campos-disponiveis/:tipo',
    INTEGRATION_HISTORY: '/integracoes/:id/historico',
    INTEGRATION_TEST: '/integracoes/:id/testar',

    // Notificações
    NOTIFICATIONS: '/notifications',
    NOTIFICATION_BY_ID: '/notifications/:id',
    NOTIFICATION_MARK_READ: '/notifications/:id/read',
    NOTIFICATION_MARK_ALL_READ: '/notifications/read-all',
    NOTIFICATION_UNREAD_COUNT: '/notifications/unread-count',
    NOTIFICATION_TEST: '/notifications/test',

    // Preferências de Tabela do Usuário
    USER_TABLE_PREFERENCES: '/user-table-preferences/:pageName',
    USER_TABLE_PREFERENCES_SAVE: '/user-table-preferences/:pageName',
    USER_TABLE_PREFERENCES_DELETE: '/user-table-preferences/:pageName',

    // Clientes
    CLIENTES: '/clientes',
    CLIENTE_BY_ID: '/clientes/:id',
    CLIENTE_ETIQUETAS: '/clientes/:clienteId/etiquetas',
    CLIENTE_ETIQUETAS_BATCH: '/clientes/:clienteId/etiquetas/batch',
    CLIENTES_TESTAR_REGEX: '/clientes/testar-regex',

    // Email Connections
    EMAIL_CONNECTIONS: '/email-connections',
    EMAIL_CONNECTION_BY_ID: '/email-connections/:id',
    EMAIL_CONNECTION_TEST: '/email-connections/:id/test',

    // Dashboard do Cliente
    CLIENT_DASHBOARD_TOKENS: '/client-dashboard/tokens',
    CLIENT_DASHBOARD_TOKEN_BY_ID: '/client-dashboard/tokens/:id',
    CLIENT_DASHBOARD_CLIENTE_USUARIOS: '/client-dashboard/clientes/:clienteId/usuarios',
    CLIENT_DASHBOARD_USUARIO_BY_ID: '/client-dashboard/usuarios/:id'
  },

  /**
   * Configurações de autenticação
   */
  AUTH: {
    TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'confereai_token',
    USER_KEY: process.env.REACT_APP_USER_KEY || 'confereai_user',
    TOKEN_EXPIRY_KEY: process.env.REACT_APP_TOKEN_EXPIRY_KEY || 'confereai_token_expiry'
  },

  /**
   * Configurações de localStorage
   */
  STORAGE: {
    PREFIX: process.env.REACT_APP_STORAGE_PREFIX || 'confereai_',
    THEME_KEY: process.env.REACT_APP_THEME_KEY || 'theme',
    LANGUAGE_KEY: process.env.REACT_APP_LANGUAGE_KEY || 'language'
  },

  /**
   * Configurações de tema
   * Cores configuráveis via variáveis de ambiente
   * Se não definidas ou em branco, usa os valores padrão
   */
  THEME: {
    PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR?.trim() || '#04364F',
    SECONDARY_COLOR: process.env.REACT_APP_SECONDARY_COLOR?.trim() || '#04C64F',
    ACCENT_COLOR: process.env.REACT_APP_ACCENT_COLOR?.trim() || '#F39C12',
    DANGER_COLOR: process.env.REACT_APP_DANGER_COLOR?.trim() || '#E74C3C',
    SUCCESS_COLOR: process.env.REACT_APP_SUCCESS_COLOR?.trim() || '#27AE60',
    WARNING_COLOR: process.env.REACT_APP_WARNING_COLOR?.trim() || '#F39C12',
    INFO_COLOR: process.env.REACT_APP_INFO_COLOR?.trim() || '#3498DB'
  },

  /**
   * Configurações de paginação
   */
  PAGINATION: {
    DEFAULT_PAGE: parseInt(process.env.REACT_APP_DEFAULT_PAGE || '1'),
    DEFAULT_LIMIT: parseInt(process.env.REACT_APP_DEFAULT_LIMIT || '10'),
    MAX_LIMIT: parseInt(process.env.REACT_APP_MAX_LIMIT || '100')
  },

  /**
   * Configurações de timeout
   */
  TIMEOUTS: {
    API_REQUEST: parseInt(process.env.REACT_APP_API_REQUEST_TIMEOUT || '30000'), // 30 segundos
    TOKEN_REFRESH: parseInt(process.env.REACT_APP_TOKEN_REFRESH_TIMEOUT || '300000'), // 5 minutos
    NOTIFICATION: parseInt(process.env.REACT_APP_NOTIFICATION_TIMEOUT || '5000') // 5 segundos
  },

  /**
   * Configurações de ambiente
   */
  ENVIRONMENT: {
    IS_DEVELOPMENT: process.env.REACT_APP_ENVIRONMENT === 'development' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
    IS_PRODUCTION: process.env.REACT_APP_ENVIRONMENT === 'production' || !(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  },

  /**
   * Mensagens do sistema
   */
  MESSAGES: {
    ERRORS: {
      NETWORK: 'Erro de conexão. Verifique sua internet e tente novamente.',
      SERVER: 'Erro interno do servidor. Tente novamente mais tarde.',
      UNAUTHORIZED: 'Sessão expirada. Faça login novamente.',
      FORBIDDEN: 'Você não tem permissão para realizar esta ação.',
      NOT_FOUND: 'Recurso não encontrado.',
      VALIDATION: 'Dados inválidos. Verifique os campos do formulário.',
      TIMEOUT: 'Tempo de requisição esgotado. Tente novamente.'
    },
    SUCCESS: {
      LOGIN: 'Login realizado com sucesso!',
      LOGOUT: 'Logout realizado com sucesso!',
      SAVE: 'Dados salvos com sucesso!',
      DELETE: 'Registro excluído com sucesso!',
      UPDATE: 'Dados atualizados com sucesso!'
    }
  }
};

/**
 * Função para construir URL completa da API
 * @param endpoint - Endpoint da API
 * @param params - Parâmetros para substituir na URL
 * @returns URL completa
 */
export const buildApiUrl = (endpoint: string, params: Record<string, string | number> = {}): string => {
  let url = Config.API_BASE_URL + endpoint;
  
  // Substituir parâmetros na URL (:id, :veiculoId, etc)
  for (const [key, value] of Object.entries(params)) {
    url = url.replace(`:${key}`, value.toString());
  }
  
  return url;
};

/**
 * Função para obter URL completa de um endpoint
 * @param endpointKey - Chave do endpoint em API_ENDPOINTS
 * @param params - Parâmetros para substituir
 * @returns URL completa
 */
export const getEndpointUrl = (endpointKey: keyof typeof Config.API_ENDPOINTS, params: Record<string, string | number> = {}): string => {
  const endpoint = Config.API_ENDPOINTS[endpointKey];
  if (!endpoint) {
    console.error(`Endpoint não encontrado: ${endpointKey}`);
    return '';
  }
  
  return buildApiUrl(endpoint, params);
};

/**
 * Função para obter token de autenticação do localStorage
 * @returns Token JWT ou null se não existir
 */
export const getToken = (): string | null => {
  return localStorage.getItem(Config.AUTH.TOKEN_KEY)
    || localStorage.getItem('conferente_token');
};

/**
 * Função para salvar token no localStorage
 * @param token - Token JWT
 */
export const setToken = (token: string): void => {
  localStorage.setItem(Config.AUTH.TOKEN_KEY, token);

  // Calcular e salvar expiração do token (assumindo 24h de validade)
  const expiryDate = new Date();
  expiryDate.setHours(expiryDate.getHours() + 24);
  localStorage.setItem(Config.AUTH.TOKEN_EXPIRY_KEY, expiryDate.toISOString());
};

/**
 * Função para remover token do localStorage
 */
export const removeToken = (): void => {
  localStorage.removeItem(Config.AUTH.TOKEN_KEY);
  localStorage.removeItem(Config.AUTH.TOKEN_EXPIRY_KEY);
  localStorage.removeItem(Config.AUTH.USER_KEY);
};

/**
 * Função para verificar se o token está expirado
 * @returns True se expirado, false caso contrário
 */
export const isTokenExpired = (): boolean => {
  const expiry = localStorage.getItem(Config.AUTH.TOKEN_EXPIRY_KEY);
  if (!expiry) return true;
  
  return new Date() > new Date(expiry);
};

/**
 * Função para obter informações do usuário logado
 * @returns Dados do usuário ou null
 */
export const getUser = (): User | null => {
  const userJson = localStorage.getItem(Config.AUTH.USER_KEY);
  return userJson ? JSON.parse(userJson) : null;
};

/**
 * Função para salvar informações do usuário
 * @param user - Dados do usuário
 */
export const setUser = (user: User): void => {
  localStorage.setItem(Config.AUTH.USER_KEY, JSON.stringify(user));
};

/**
 * Função para verificar se usuário está autenticado
 * @returns True se autenticado, false caso contrário
 */
export const isAuthenticated = (): boolean => {
  const token = getToken();
  const user = getUser();
  return !!token && !!user && !isTokenExpired();
};

/**
 * Função para obter headers padrão para requisições API
 * @returns Headers HTTP
 */
export const getDefaultHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  const token = getToken();

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    // Verificar se há dados de usuário sem token (inconsistência)
    const user = getUser();
    if (user) {
      removeToken(); // Limpar tudo para evitar estado inconsistente
    }
  }

  return headers;
};

